import React from 'react'

class TypeElement extends React.Component {

}

export default TypeElement
